import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { AddVariable } from '../../api/variables-endpoint';
import SnackbarAlert from '../../components/Alerts';
import CancelButton from '../../components/CancelButton';
import VariableDetails from '../../components/variables/VariableDetails';
import useConfigStyles from '../../components/useConfigStyles';
import SubmitButton from '../../components/SubmitButton';
import { getLinkToVariable } from '../../navigator/links';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVariablesContext } from '../../stores/variables-context';
import { Variable } from '../../types/variable';
import { defaultVariable } from '../../types/defaultValues';

function VariableEditPage(): JSX.Element {
  const [variable, setVariable] = useState<Variable>(defaultVariable);
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const classes = useConfigStyles();
  const navigate = useNavigate();
  const variablesContext = useVariablesContext();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const response = await AddVariable(variable);
    if (response.success) {
      setResponseMessage('Success');
      variablesContext.fetchData();
      navigate(getLinkToVariable(variable.Name));
    } else {
      setResponseMessage(response.message || '');
      setErrors(response.errors || {});
    }
    toggleNotification(true);
  };

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const cleanErrors = (name: string) => {
    if (errors[name]) {
      delete errors[name];
    }
  };

  const handleVariableUpdate = (updatedVariable: Variable, fieldName: string) => {
    setVariable(updatedVariable);
    cleanErrors(fieldName);
  };

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <Card>
        <CardContent>
          <VariableDetails variable={variable} editable errors={errors} onVariableUpdate={handleVariableUpdate} />
        </CardContent>
        <CardActions>
          <Grid container alignItems='center' justifyContent='center' direction='row' spacing={5}>
            <Grid item>
              <CancelButton label='Back' className={classes.button} onClick={handleCancelClick} />
            </Grid>
            <Grid item>
              <SubmitButton className={classes.button} label='Create Variable' />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
    </form>
  );
}

export default VariableEditPage;
